import { GameType } from '@/models/games/enums/GameType';
import { ThaiHiLoResult } from '@/models/games/thaiHiLo';
import { TableMode } from '@/models/TableMode';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import {
    convertResultToRecord,
    getResultForFResult,
} from '@/utils/games/thaiHiLo';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import { CMDScInitThaihilo, ICommand } from '../live';
import { CMDThaihilo } from '../live/CMDThaihilo';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitThaiHiLoHandler extends AbstractHandler {
    _command: CMDScInitThaihilo;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitThaihilo;
    }
    override convertResult(result: CMDThaihilo): ThaiHiLoResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                Dice1: result.Detail.Dice1,
                Dice2: result.Detail.Dice2,
                Dice3: result.Detail.Dice3,
            },
            getResultForFResult(result.BaseResult.FResult)
        ) as ThaiHiLoResult;
        return newResult;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        liveData.GameType = GameType.ThaiHiLo;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if ((o as CMDThaihilo).BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );
        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;
        const convertedRecord = game.OldResult.map(r =>
            convertResultToRecord(r as ThaiHiLoResult)
        );
        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseResult.GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record:
                        convertedRecord.length > 50
                            ? convertedRecord.splice(
                                  convertedRecord.length - 50
                              )
                            : convertedRecord,
                })
            );
        });
    }
}
